/*
 * Automatisk leveringsdato i Zapiet
 *
 * Når kurven indeholder varer, hvor kunden ikke selv må vælge leveringsdag
 * (markeret af snippets/zapiet-auto-delivery-date.liquid), skjules Zapiets
 * datovælger under "Greenify Levering", og den første ledige dag vælges i
 * stedet automatisk. Zapiet gemmer datoen som _ZapietId på varerne i kurven,
 * præcis som hvis kunden selv havde klikket.
 *
 * Zapiet har intet offentligt API til at sætte en dato, så vi klikker på
 * dagen i Zapiets egen (skjulte) kalender. Kan der ikke vælges en dato
 * inden for PICK_TIMEOUT, vises datovælgeren igen, så kunden aldrig står
 * uden mulighed for at komme videre.
 */
(function () {
  var APP_ID = 'storePickupApp';
  var PICKER = '#deliveryDatePicker';
  var INPUT = '#Zapiet-InputCalendar__delivery';
  var ISO_INPUT = '#Zapiet-InputCalendar__deliveryDate_ISO';
  var AVAILABLE_DATE = '#Zapiet-Calendar__delivery .Zapiet-Calendar__Dates button[aria-disabled="false"]';
  var MONTH_NAV = '#Zapiet-Calendar__delivery .Zapiet-Calendar__Nav';
  var ACTIVE_CLASS = 'is-auto-delivery-date';
  var NOTE_CLASS = 'ZapietAutoDate__Note';
  var LOCK_ATTR = 'data-zapiet-auto-date-lock';

  var PICK_TIMEOUT = 10000;
  var VERIFY_TIMEOUT = 6000;
  var CLICK_RETRY = 1500;
  var MAX_MONTH_STEPS = 2;

  var state = {
    failed: false,
    pendingSince: 0,
    lastClickLabel: null,
    lastClickAt: 0,
    monthSteps: 0,
    verifiedDate: null,
    verifyingDate: null,
    retryTimer: null
  };

  function getConfig() {
    return document.querySelector('[data-zapiet-auto-date]');
  }

  function getCheckoutButton() {
    return document.getElementById('checkoutButton');
  }

  // Lås kun knappen, hvis vi selv har låst den - andre scripts må gerne styre disabled
  function lockCheckout() {
    var button = getCheckoutButton();
    if (!button || button.hasAttribute(LOCK_ATTR)) return;
    button.setAttribute(LOCK_ATTR, '');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }

  function unlockCheckout() {
    var button = getCheckoutButton();
    if (!button || !button.hasAttribute(LOCK_ATTR)) return;
    button.removeAttribute(LOCK_ATTR);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }

  // Noten placeres som søskende til Zapiets app, ikke inde i den, så Zapiets
  // egen gentegning ikke fjerner den
  function renderNote(app, text) {
    var note = app.parentNode.querySelector('.' + NOTE_CLASS);
    if (!text) {
      removeNote(app);
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = NOTE_CLASS;
      app.parentNode.insertBefore(note, app.nextSibling);
    }
    if (note.textContent !== text) note.textContent = text;
  }

  function removeNote(app) {
    var note = app.parentNode && app.parentNode.querySelector('.' + NOTE_CLASS);
    if (note) note.parentNode.removeChild(note);
  }

  function resetPending() {
    state.pendingSince = 0;
    state.lastClickLabel = null;
    state.monthSteps = 0;
  }

  function deactivate(app) {
    app.parentNode.classList.remove(ACTIVE_CLASS);
    removeNote(app);
    unlockCheckout();
    resetPending();
  }

  function scheduleRetry() {
    clearTimeout(state.retryTimer);
    state.retryTimer = setTimeout(sync, 400);
  }

  // Zapiet skriver datoen til hver linje i kurven med separate kald. Checkout
  // låses op først, når alle linjer har fået den valgte dato.
  function verifyCart(isoDate) {
    if (state.verifyingDate === isoDate || state.verifiedDate === isoDate) return;
    state.verifyingDate = isoDate;

    var expected = 'D=' + isoDate.replace(/\//g, '-');
    var startedAt = Date.now();

    function check() {
      fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (state.verifyingDate !== isoDate) return;

          var complete = cart.items.length > 0 && cart.items.every(function (item) {
            var zapietId = item.properties && item.properties._ZapietId;
            return typeof zapietId === 'string' && zapietId.indexOf(expected) !== -1;
          });

          // Efter timeout overlades valideringen til Zapiet selv
          if (complete || Date.now() - startedAt > VERIFY_TIMEOUT) {
            state.verifiedDate = isoDate;
            state.verifyingDate = null;
            unlockCheckout();
          } else {
            setTimeout(check, 400);
          }
        })
        .catch(function () {
          state.verifiedDate = isoDate;
          state.verifyingDate = null;
          unlockCheckout();
        });
    }

    check();
  }

  function sync() {
    var app = document.getElementById(APP_ID);
    if (!app) return;

    var config = getConfig();
    if (!config || state.failed) {
      deactivate(app);
      return;
    }

    // Klassen sættes på forælderen, da Zapiet overskriver class på sin egen container
    app.parentNode.classList.add(ACTIVE_CLASS);

    var picker = app.querySelector(PICKER);
    if (!picker) {
      // Levering er ikke valgt, eller postnummeret er endnu ikke søgt frem
      removeNote(app);
      unlockCheckout();
      resetPending();
      return;
    }

    renderNote(app, config.getAttribute('data-note'));

    var input = app.querySelector(INPUT);
    var isoInput = app.querySelector(ISO_INPUT);
    var firstDate = app.querySelector(AVAILABLE_DATE);
    var firstLabel = firstDate && firstDate.getAttribute('aria-label');

    // Første ledige dag er valgt - vent på at kurven er opdateret
    if (firstLabel && input && input.value === firstLabel && isoInput && isoInput.value) {
      resetPending();
      if (state.verifiedDate === isoInput.value) {
        unlockCheckout();
      } else {
        lockCheckout();
        verifyCart(isoInput.value);
      }
      return;
    }

    lockCheckout();
    state.verifiedDate = null;
    if (!state.pendingSince) state.pendingSince = Date.now();

    if (Date.now() - state.pendingSince > PICK_TIMEOUT) {
      state.failed = true;
      deactivate(app);
      return;
    }

    if (firstDate) {
      var now = Date.now();
      if (state.lastClickLabel !== firstLabel || now - state.lastClickAt > CLICK_RETRY) {
        state.lastClickLabel = firstLabel;
        state.lastClickAt = now;
        firstDate.click();
      }
    } else if (state.monthSteps < MAX_MONTH_STEPS) {
      // Ingen ledige dage i den viste måned - bladr frem
      var navs = app.querySelectorAll(MONTH_NAV);
      var next = navs[navs.length - 1];
      if (next && next.getAttribute('aria-disabled') !== 'true') {
        state.monthSteps += 1;
        next.click();
      }
    }

    scheduleRetry();
  }

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      sync();
    }, 100);
  }

  function init() {
    var root = document.getElementById('main') || document.body;
    new MutationObserver(queueSync).observe(root, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
